export const PopupType = {
  NORMAL: '일반',
  ADVERTISE: '광고',
} as const;

export const PopupStatus = {
  WAITING: '대기',
  SHOWING: '노출',
  ENDED: '마감',
} as const;

export const DeviceType = {
  PC: 'PC',
  MOBILE: '모바일',
} as const;

export const NOT_TODAY_ADVERTISE_POPUP = 'G4maudwOL89Gg4kV8ocNnwVsjmwduvBE';
export const NOT_TODAY_NORMAL_POPUP = 'zw7IWBLzLCFyvXYJFAqG8CunRG6Zjfe8';
